module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remain-main"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('div', {
    staticClass: "text-center _title"
  }, [_vm._v("Get verified")]), _vm._v(" "), _c('hr', {
    staticClass: "margin-vertical"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-days"
  }, [_vm._v("\n\t\t\t " + _vm._s(_vm.daysRemaining) + " Days\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/cross.svg"),
      "width": "11"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-flex mt-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/watch.png"),
      "width": "32"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-vertical text-center"
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v("Your account was reviewed & denied.")]), _vm._v(" "), _c('p', [_vm._v("You can re-apply in:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c699e482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UpgradeModal/index.vue
// module id = 1848
// module chunks = 180